import BringOutBestMolderm from "../img/BringOutBestMolderm.png"
import YouthfulMoisture from "../img/YouthfulMoisture.png"
import LipsMolderm from "../img/LipsMolderm.png"
import MoldermClassic from "../img/MoldermClassic.png"
import MoldermGlowPlus from "../img/MoldermGlowPlus.png"

const brands = [
    {
        name: "Crafted in Sweden, Made in Switzerland",
        image: BringOutBestMolderm,
        description: "Molderm® - den senaste utvecklingen av fillers.",
        url: "https://molderm.com/?lang=sv"
    },
    {
        name: "Fantastisk lyster, varje dag",
        image: YouthfulMoisture,
        description: "MOLDERM® GLOW är en del av Molderm Aesthetics banbrytande anti-aging program som även inkluderar MOLDERM® GLOW+.",
        url: "https://molderm.com/produkter/glow/?lang=sv"
    },
    {
        name: "För sofistikerade, vackra läppar",
        image: LipsMolderm,
        description: "MOLDERM® LIPS är framtagen med hjälp av vår patenterade Fine-Tuning Technology™, för att ge den perfekta balansen av volym, definition och hydrering. Resultaten är långvariga och helt utan migrering.",
        url: "https://molderm.com/produkter/lips/?lang=sv"
    },
    {
        name: "Skönhetens vetenskap",
        image: MoldermClassic,
        description: "Baserat på vår patenterade Fine-Tuning Technology™ för optimalt lyft och reduktion av oönskade rynkor och linjer",
        url: "https://molderm.com/produkter/classic/?lang=sv"
    },
    {
        name: "Reducera föråldringsprocessen",
        image: MoldermGlowPlus,
        description: "MOLDERM® GLOW+ är en del av Molderm Aesthetics banbrytande anti-aging program som även inkluderar MOLDERM® GLOW.",
        url: "https://molderm.com/produkter/glow_plus/?lang=sv"
    }
]

export default brands